import { useEffect, useState } from "react";
import api, { fmtUSD } from "@/lib/api";
import { Panel, Table, Metric, Empty, StatusBadge } from "@/components/terminal";

export default function YieldPage() {
  const [d, setD] = useState(null);
  const [events, setEvents] = useState([]);
  useEffect(() => {
    api.get("/dashboard").then((r) => setD(r.data)).catch(() => {});
    api.get("/tax/events").then((r) => setEvents(r.data.filter((e) => e.income_amount > 0))).catch(() => {});
  }, []);
  if (!d) return <div className="text-slate-500 font-mono text-sm">Loading…</div>;
  return (
    <div className="space-y-5" data-testid="yield-page">
      <h2 className="font-display text-xl font-bold">Yield & Income</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Metric label="Income Generated" value={fmtUSD(d.income_generated)} testId="yield-income" />
        <Metric label="Rewards Earned" value={fmtUSD(d.rewards_earned)} testId="yield-rewards" />
        <Metric label="Staked Asset Value" value={fmtUSD(d.staked_value)} testId="yield-staked" />
        <Metric label="Income / Yield Bucket" value={fmtUSD(d.buckets.find((b) => b.key === "income_yield")?.balance)} testId="yield-bucket" />
      </div>
      <Panel title="Income Events (tax-recognized)" testId="yield-events">
        {events.length === 0 ? <Empty>No income events yet. Staking rewards, interest, dividends, and referral income appear here and are never allowed to disappear from accounting.</Empty> : (
          <Table testId="yield-events-table" head={[{ label: "Time" }, { label: "Type" }, { label: "Asset" }, { label: "Income", num: true }, { label: "Est. Tax", num: true }, { label: "Status" }]}>
            {events.map((e) => (
              <tr key={e.id} className="hover:bg-[#222630]">
                <td className="td-cell font-mono">{new Date(e.timestamp).toLocaleString()}</td>
                <td className="td-cell">{e.event_type.replace(/_/g, " ")}</td>
                <td className="td-cell">{e.asset}</td>
                <td className="td-num text-emerald-400">{fmtUSD(e.income_amount)}</td>
                <td className="td-num text-amber-400">{fmtUSD(e.estimated_total_tax)}</td>
                <td className="td-cell"><StatusBadge status={e.status} /></td>
              </tr>
            ))}
          </Table>
        )}
      </Panel>
      <Panel title="Staking Engine" testId="staking-panel">
        <Empty>
          No staking positions tracked. Staking accounting (rates, bonding/unbonding, tax effects) is ready and
          activates when a provider reports staking positions. Hussar Treasury never recommends purchasing an
          asset solely for staking yield.
        </Empty>
      </Panel>
    </div>
  );
}
